import React from "react";
import { Card } from "@/components/ui/card";
import { XCircle, CheckCircle2 } from "lucide-react";
import { myths } from "@/data/articles";
import ImagePlaceholder from "@/components/ImagePlaceholder";
import Seo from "@/components/Seo";

export default function Myths() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-16 lg:py-24">
      <Seo
        title="Mythen und Fakten zur Lactoseintoleranz"
        description="Die häufigsten Halbwahrheiten über Lactoseintoleranz klar widerlegt. Fundierte Fakten zu Käse Joghurt Milch und Toleranzschwellen."
        path="/mythen-und-fakten"
      />
      <div className="grid lg:grid-cols-12 gap-10 items-center mb-12">
        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-wide text-emerald-700 font-semibold mb-3">Mythen & Fakten</div>
          <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">Was stimmt - und was nicht?</h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Rund um Lactoseintoleranz kursieren viele Halbwahrheiten. Wir sortieren die häufigsten Missverständnisse - ohne Panikmache, mit klaren Fakten.
          </p>
        </div>
        <div className="lg:col-span-5">
          <ImagePlaceholder src="https://images.pexels.com/photos/1104756/pexels-photo-1104756.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" label="Milk splash" ratio="aspect-[4/3]" />
        </div>
      </div>

      <div className="space-y-6">
        {myths.map((m, i) => (
          <Card key={i} className="p-8 rounded-2xl border-slate-100 grid md:grid-cols-2 gap-8" data-testid={`myth-detail-${i}`}>
            <div>
              <div className="flex items-center gap-2 text-red-500 text-xs uppercase tracking-wide font-semibold mb-3">
                <XCircle className="w-4 h-4" /> Mythos
              </div>
              <div className="text-slate-900 font-semibold text-lg leading-snug">{m.myth}</div>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-slate-100 pt-6 md:pt-0 md:pl-8">
              <div className="flex items-center gap-2 text-emerald-700 text-xs uppercase tracking-wide font-semibold mb-3">
                <CheckCircle2 className="w-4 h-4" /> Fakt
              </div>
              <div className="text-slate-700 leading-relaxed">{m.fact}</div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
